import React from 'react';
import { Companies } from '../modules/companies';

export const CompaniesPage = () => {
    return (
        <Companies />
    );
};